import React, { Component } from 'react';
import { selectors as session_selectors } from './sagas/session';
import MainDrawer from './InternalNavigation/drawer';
import InternalNavigation from './InternalNavigation';
import { NavLink } from 'react-router-dom'
import Product from './Products/product';
import { selectors, actions } from './sagas/products';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import plusSquare from '@fortawesome/fontawesome-free-solid/faPlusSquare'
import NoProducts from './Products/NoProducts'
import './stylesheets/products.sass'

class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawer: false
    };
  }

  toggleDrawer = () => {
    this.setState({drawer: !this.state.drawer})
  }

  componentWillMount() {
    this.props.getProducts()
  }


  render () {
    console.log(this.props.products)
    return (
      <div>
        <MainDrawer
          position={'left'}
          openState={this.state.drawer}
          toggleDrawer={this.toggleDrawer}
          className='drawer'/>
        <InternalNavigation
          toggleDrawer={this.toggleDrawer}/>
        <div className={'product-page'}>
          <div className='product-title'>
            <div className='page-title'>
              Products
            </div>
          </div>
            <div className={'product-row'}>
              { checkRole('admin', this.props.role) &&
              <NavLink to='/new_product'>
                <div className={'product-card'}>
                  <FontAwesomeIcon className={'plus'} style={{ 'height': 100, 'width': 100 }} icon={plusSquare} />
                  <div className={'new-product'}>
                    Create Product
                  </div>
                </div>
              </NavLink>
              }
              {
                this.props.products &&
                this.props.products.length > 0 &&
                this.props.products.map( product =>
                  <Product
                    key={ product['id'] }
                    product={product}
                    role={ this.props.role }
                  />
                )
              }
            </div>
            { this.props.products && this.props.products.length === 0 &&
              <NoProducts />
            }
        </div>
      </div>
    );
  }
};

const checkRole = (minRole, role) => {
  return roleCanView()[role].includes(minRole)
}

const roleCanView = () => ({
  'admin': ['admin', 'accountant', 'user'],
  'accountant': ['accountant', 'user'],
  'user': ['user']
})

const mapStateToProps = (store) => ({
  products: selectors.products(store),
  role: session_selectors.role(store)
})

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Products)



// WEBPACK FOOTER //
// ./src/Products.jsx